import { AttributesMixin, define, Model } from "@type-r/models";
import { getAuthorizationBearer, getPlatformCode, restfulIO } from "./endpoint";


export interface InvoiceBulkDelete extends AttributesMixin<typeof InvoiceBulkDelete> { }
@define
export class InvoiceBulkDelete extends Model {
  static endpoint = restfulIO('api/v1/assetmaster/invoices/assets/bulkdelete');

  static attributes = {
    status: String
  }

  async do(ids: string): Promise<Response> {
    const url = `api/v1/assetmaster/invoices/assets/bulkdelete`;
    
    return await fetch(url, {
      method: 'DELETE',
      headers: new Headers({
        'Content-Type': 'application/json',
        "Authorization": getAuthorizationBearer(),
        'X-Platform-Code': getPlatformCode()
      }),
      body: JSON.stringify({
        "assetIds": ids
      })
    });
  }
}
